import { defineMessages } from 'react-intl';

export default defineMessages({
    driverGroupInfoLine1: {
        id: 'ml.quoteandbind.pa.prefill.WellIncludeTheseDrivers',
        defaultMessage: 'We\'ll include these drivers when calculating your quote'
    },
    driverGroupInfoLine2: {
        id: 'ml.quoteandbind.pa.prefill.WeFoundTheseDrivers',
        defaultMessage: 'We found these drivers associated with your household. Remove any that aren\'t yours.'
    },
    driverGroupInfoLine2QB: {
        id: 'ml.quoteandbind.pa.prefill.We Found These DriversQB',
        defaultMessage: 'We found these drivers associated with your household. Remove any that are incorrect.'
    },
    vehicleGroupInfoLine1: {
        id: 'ml.quoteandbind.pa.prefill.WellIncludeTheseVehicles',
        defaultMessage: 'We\'ll include these vehicles when calculating your quote'
    },
    vehicleGroupInfoLine2: {
        id: 'ml.quoteandbind.pa.prefill.WeFoundTheseVehicles',
        defaultMessage: 'We found these vehicles associated with your household. Remove any that aren\'t yours.'
    },
    vehicleGroupInfoLine2QnB: {
        id: 'ml.quoteandbind.pa.prefill.We Found These Vehicles. that are incorrect',
        defaultMessage: 'We found these vehicles associated with your household. Remove any that are incorrect.'
    },
    age: {
        id: 'ml.quoteandbind.pa.prefill.Age',
        defaultMessage: 'Age'
    },
    remove: {
        id: 'ml.quoteandbind.pa.prefill.Remove',
        defaultMessage: 'Remove'
    },
    yesRemove: {
        id: 'ml.quoteandbind.pa.prefill.YesRemove',
        defaultMessage: 'Yes, Remove'
    },
    dontRemove: {
        id: 'ml.quoteandbind.pa.prefill.DontRemove',
        defaultMessage: 'Don\'t Remove'
    },
    addDriver: {
        id: 'ml.quoteandbind.pa.prefill.ADD A DRIVER',
        defaultMessage: 'ADD A DRIVER'
    },
    dontSeeADriverListed: {
        id: 'ml.quoteandbind.pa.prefill.DontSeeADriverListed',
        defaultMessage: 'Don\'t see a driver listed?'
    },
    addVehicle: {
        id: 'ml.quoteandbind.pa.prefill.ADD A VEHICLE',
        defaultMessage: 'ADD A VEHICLE'
    },
    dontSeeAVehicleListed: {
        id: 'ml.quoteandbind.pa.prefill.DontSeeAVehicleListed',
        defaultMessage: 'Don\'t see a vehicle listed?'
    },
    vin: {
        id: 'ml.quoteandbind.pa.prefill.VIN',
        defaultMessage: '{vin} {value}'
    },
    weWillWorkOnYourDriversNext: {
        id: 'quoteandbind.pa.views.ml-pa-prefill.We\'ll work on your drivers next',
        defaultMessage: 'We\'ll work on your {drivers} next'
    },
    drivers: {
        id: 'ml.quoteandbind.pa.prefill.drivers',
        defaultMessage: 'drivers'
    },
    addNewDriver: {
        id: 'ml.quoteandbind.pa.prefill.addNewDriver',
        defaultMessage: 'Add New Driver'
    },
    editDriver: {
        id: 'ml.quoteandbind.pa.prefill.editDriver',
        defaultMessage: 'Edit Driver'
    },
    hvqNextDescription: {
        id: 'ml.quoteandbind.pa.views.ml-pa-prefill.We\'ll review your driver details next',
        defaultMessage: 'We\'ll review {yourDriverDetails} next'
    },
    hvqYourDriverDetails: {
        id: 'ml.quoteandbind.pa.prefill.your driver details',
        defaultMessage: 'your driver details'
    },
    hasBeenAdded: {
        id: 'ml.quoteandbind.pa.prefill.has been added.',
        defaultMessage: 'has been added.'
    },
    hasBeenEdited: {
        id: 'ml.quoteandbind.pa.prefill.has been edited.',
        defaultMessage: 'has been edited.'
    },
    hasBeenRemoved: {
        id: 'ml.quoteandbind.pa.prefill.has been removed.',
        defaultMessage: 'has been removed.'
    },
    notAValidReasonToRemoveThisDriver: {
        id: 'ml.quoteandbind.pa.prefill.The reason selected is not a valid reason to remove this driver.  We require this person to be listed as a driver.',
        defaultMessage: 'The reason selected is not a valid reason to remove this driver.  We require this person to be listed as a driver.'
    },
    cannotRemoveMarriedDriver: {
        id: 'ml.quoteandbind.pa.prefill.cannotRemoveMarriedDriver',
        defaultMessage: 'To continue, please identify your spouse from the drivers on this policy'
    },
    selfSelected_Ext: {
        id: "ml.quoteandbind.pa.prefill.Self has already been selected as a relationship to insured on another driver.",
        defaultMessage: "Self has already been selected as a relationship to insured on another driver."
    },
    spouseSelected_Ext: {
        id: "ml.quoteandbind.pa.prefill.Spouse was already selected as a relationship to insured on another driver.",
        defaultMessage: "Spouse was already selected as a relationship to insured on another driver."
    },
    prefillIncomplete_Ext: {
        id: "ml.quoteandbind.pa.prefill.Items marked with a (!) need your attention. Please click the edit link and fill out all required fields.",
        defaultMessage: "Items marked with a (!) need your attention. Please click the edit link and fill out all required fields."
    },
    prefillEditVehicleHeading: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.prefill.Edit vehicle',
        defaultMessage: 'Edit vehicle'
    },
    prefillEditVehicleSubTitle: {
        id: 'ml.quoteandbind.pa.prefill.partialVehicleDetail.The quoted rate may change when updating this information',
        defaultMessage: 'The quoted rate may change when updating this information'
    },
    prefillNewVehicleHeading: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.prefill.Add a new vehicle to your quote',
        defaultMessage: 'Add a new vehicle to your quote'
    },
    prefillNewVehicleSubTitle: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.prefill.Enter your make and model details. The quoted rate may change when updating this information',
        defaultMessage: 'Enter your make and model details{br}The quoted rate may change when updating this information'
    },
    exceedVehicleLimit: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.prefill.Online quotes are limited to Five vehicles. Please remove the extra vehicle(s) or call 1-800-438-6381 to speak with a representative',
        defaultMessage: 'Online quotes are limited to Five vehicles. Please remove the extra vehicle(s) or call 1-800-438-6381 to speak with a representative'
    },
    exceedDriverLimit: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.prefill.Online quotes are limited to Five drivers. Please remove the extra driver(s) or call 1-800-438-6381 to speak with a representative',
        defaultMessage: 'Online quotes are limited to Five drivers. Please remove the extra driver(s) or call 1-800-438-6381 to speak with a representative'
    },
     aTrailerOrCamperCannotBeTheOnlyVehicleOnThePolicy: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.prefill.A trailer or camper cannot be the only vehicle on the policy',
        defaultMessage: 'A trailer or camper cannot be the only vehicle on the policy.'
    },
     noVehicleSelected: {
        id: 'ml.quoteandbind.pa.partialVehicleDetail.prefill.No vehicle selected. Please add or select a vehicle to proceed with your quote',
        defaultMessage: 'No vehicle selected. Please add or select a vehicle to proceed with your quote'
    },
});
